import { render, staticRenderFns } from "./AddAutomationRule.vue?vue&type=template&id=400be48e&scoped=true&"
import script from "./AddAutomationRule.vue?vue&type=script&lang=js&"
export * from "./AddAutomationRule.vue?vue&type=script&lang=js&"
import style0 from "./AddAutomationRule.vue?vue&type=style&index=0&id=400be48e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "400be48e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('400be48e')) {
      api.createRecord('400be48e', component.options)
    } else {
      api.reload('400be48e', component.options)
    }
    module.hot.accept("./AddAutomationRule.vue?vue&type=template&id=400be48e&scoped=true&", function () {
      api.rerender('400be48e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/routes/dashboard/settings/automation/AddAutomationRule.vue"
export default component.exports